import i18n from "i18next";

const i18nPtBR = i18n.cloneInstance();
i18nPtBR.changeLanguage("pt-BR");

export default i18nPtBR;
